var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0001 0.600006C1.2269 0.600006 0.600098 1.22681 0.600098 2.00001V10.5C0.600098 11.2732 1.2269 11.9 2.0001 11.9H9.0001H9.4001V11.5V9.50001V9.10001V1.00001V0.600006H9.0001H2.0001ZM8.6001 9.10001V1.40001H2.0001C1.66873 1.40001 1.4001 1.66864 1.4001 2.00001V9.23473C1.58195 9.14834 1.78538 9.10001 2.0001 9.10001H8.6001ZM1.4001 10.5C1.4001 10.8314 1.66873 11.1 2.0001 11.1H8.6001V9.90001H2.0001C1.66873 9.90001 1.4001 10.1686 1.4001 10.5ZM3.0001 2.60001H2.6001V3.00001V5.00001V5.40001H3.0001H7.0001H7.4001V5.00001V3.00001V2.60001H7.0001H3.0001ZM3.4001 4.60001V3.40001H6.6001V4.60001H3.4001Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book-icon.2c81830c095a294a5ec3753db3f3a884.svg";
export { ForwardRef as ReactComponent };